var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBreadcrumbSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 1.3335L2.80313 2.78959C3.97474 3.95079 4.56054 4.53139 4.65074 5.23905C4.67284 5.41244 4.67284 5.58789 4.65074 5.76127C4.56054 6.46893 3.97474 7.04954 2.80313 8.21074L1.33398 9.66683",
    stroke: "#8F8F8F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbSeparator);
export default __webpack_public_path__ + "static/media/breadcrumbSeparator.4b8a91ebeb5d4edc716d4aff03113746.svg";
export { ForwardRef as ReactComponent };